// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_PASSWORD_RESET = "Obnovenie hesla";
